import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import useAppContext from '../../contexts/UseAppContext';
import Button from '../../components/Button/Button';
import Question from '../../components/Question/Question';
import DataError from '../../components/DataError/DataError';
import Activity from '../../helpers/Activity';
import ExternalAnalytics from '../../helpers/ExternalAnalytics';
import Navigation from '../../config/Navigation';
import {Question as _Question, Answer as _Answer} from '../../models/Question';
import './Identification.css';

function Identification({section}) {
    const navigate = useNavigate();
    const context = useAppContext();
    const shoppingCart = context.shoppingCart;
    const nextLinkLabel = 'Siguiente';
    const [isClient, setIsClient] = useState(undefined);

    useEffect(() => {
        const sources = shoppingCart && shoppingCart.hasItems() ? shoppingCart.items : undefined;
        ExternalAnalytics.beginCheckout(sources, section);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMetadata = (additionalData, customQuantity) => {
        const metadata = {shopping_cart: shoppingCart ? shoppingCart.toActivityLog(customQuantity) : null}; // This is a snapshot of the contents of the cart when an action is performed, it's not the current state.
        if (additionalData) return {...metadata, ...additionalData};
        else return metadata;
    };

    const onIsClientAnswer = (questionId, answerId) => {
        if (questionId === 'is-client') {
            const source = shoppingCart && shoppingCart.hasItems() ? shoppingCart.items[0] : undefined;
            const label = getQuestion().answers.find((answer) => answer.id === answerId)?.label;
            ExternalAnalytics.identificationInteraction(source, section, 'radio-button', label);
            Activity.log('identification-view', 'client-type-select', 'click', getMetadata({is_client: answerId === 'yes'}));
            setIsClient(answerId === 'yes');
        }
    };

    const toHome = (error) => {
        Activity.log('identification-view', 'scan-button', 'click', getMetadata({error: error || null}));
        const url = Navigation.getHomeUrl();
        navigate(url);
    };

    const toAddressCopy = () => {
        const source = shoppingCart && shoppingCart.hasItems() ? shoppingCart.items[0] : undefined;
        ExternalAnalytics.clickToAction(source, section, 'button', nextLinkLabel);
        Activity.log('identification-view', 'next-button', 'click', getMetadata({is_client: isClient}));
        const path = isClient ? 'client' : 'public';
        const url = Navigation.getAddressCopyUrl(path);
        navigate(url);
    };

    const getQuestion = () => {
        return new _Question({
            id: 'is-client',
            title: '¿Eres cliente Entel?',
            answers: [
                new _Answer({id: 'yes', label: 'Sí, soy cliente', selected: isClient === true}),
                new _Answer({id: 'no', label: 'No, soy público general', selected: isClient === false})
            ]
        });
    };

    const wrapperStyle = () => {
        return {
            marginBottom: context.identificationNextButtonHeight
        };
    };

    const renderPages = () => {
        return (
            <>
                <div className='identification_page'>
                    <Question questionIndex={0} question={getQuestion()} questionsQuantity={0} onAnswerClick={onIsClientAnswer}/>
                </div>
            </>
        );
    };

    if (!shoppingCart || !shoppingCart.items || shoppingCart.items.length === 0) {
        return (
            <div className='identification_data-error'>
                <DataError
                    message='El carro de compras está vacío'
                    actionLabel='Escanear un producto'
                    action={() => toHome('S&G-empty')}
                    padding={20}
                    maxWidth={undefined}
                    iconSize={undefined}
                    fontSize={undefined}
                />
            </div>
        );
    } else {
        return (
            <div className='identification'>
                <div className='identification_wrapper' style={wrapperStyle()}>
                    <div className='identification_pages'>
                        {renderPages()}
                    </div>
                    <div className='identification_footer'>
                        <div className='identification_buttons'>
                            <div className='identification_button'>
                                <Button
                                    icon={undefined}
                                    label={nextLinkLabel}
                                    labelColor='#FFFFFF'
                                    backgroundColor='#002EFF'
                                    borderColor='#002EFF'
                                    borderWidth={0}
                                    borderRadius={0}
                                    padding='15px 10px'
                                    paddingTarget='label'
                                    margin={0}
                                    width='100%'
                                    minWidth={undefined}
                                    maxWidth={undefined}
                                    height={context.identificationNextButtonHeight}
                                    minHeight={undefined}
                                    maxHeight={undefined}
                                    transition='label'
                                    fontSize={18}
                                    boxShadow='unset'
                                    isLoading={false}
                                    loadLabel={undefined}
                                    disabled={isClient === undefined}
                                    showPulseEffect={false}
                                    notificationNumber={undefined}
                                    notificationBackgroundColor={undefined}
                                    notificationLabelColor={undefined}
                                    onClick={toAddressCopy}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Identification;